import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  createdTsById,
  emailById,
  expirationTimeById,
  nameById,
  referrerNameById,
  sourceById,
} from '/redux/selector/candidate.selector';

import Header from './Header';

export default connect(
  createStructuredSelector({
    name: nameById,
    email: emailById,
    source: sourceById,
    createdOn: createdTsById,
    referrerName: referrerNameById,
    expirationTime: expirationTimeById,
  }),
)(Header);
